import { parseISO } from 'date-fns';
import { InterimsDTO } from './interimsModels';
import { ValuesType } from 'utility-types';

export const sumUsage = (first: number | null, second: number | null) =>
  first === null || second === null ? null : first + second;

export const mapInterimsDTO = (interims: InterimsDTO, imsi: string) => {
  return interims.map((interim) => ({
    id: `${interim.acctSessionId}-${interim.statusLastUpdated}-${imsi}`,
    timestamp: parseISO(interim.statusLastUpdated),
    usage: sumUsage(interim.deltaInputUsage, interim.deltaOutputUsage) ?? 0,
    cumulativeUsage: sumUsage(interim.cumulativeInputUsage, interim.cumulativeOutputUsage) ?? 0,
    localization: interim.localization,
    radioAccess: interim.ratType,
    operatorCode: interim.operatorCode,
    lastRadiusType: interim.lastRadiusType,
    inputUsage: interim.deltaInputUsage ?? 0,
    outputUsage: interim.deltaOutputUsage ?? 0,
  }));
};

export type Interim = ValuesType<ReturnType<typeof mapInterimsDTO>>;
export type Interims = ReturnType<typeof mapInterimsDTO>;
